import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/i18n';
import './styles/responsive.css';
import * as process from 'process';
import { validateEnvironment } from './config/validateEnvironment';

window.global = window;
window.process = process;
window.Buffer = [];
validateEnvironment();
createRoot(document.getElementById("root")).render(<App />);

